import ChatService from "../../../common/services/chat/ChatService";
import MessageService from "../../../common/services/chat/MessageService";
import NegotiationDetailService from "../../../common/services/chat/NegotiationDetailService";
import NegotiationService from "../../../common/services/chat/NegotiationService";
import CustomerService from "../../../common/services/customer/CustomerService";

import {
    ADD_MESSAGE,
    CREATE_MESSAGE,
    CREATE_NEGOTIATION,
    GET_CHAT_MESSAGES,
    GET_CUSTOMER_CHATS,
    GET_CUSTOMER_CHAT,
    GET_MESSAGES,
    SWITCH_CHAT_DIALOG,
    UPDATE_MESSAGE,
    UPDATE_NEGOTIATION,
} from "./actions";

import {KIT_CURRENCY} from '../store/actions'

export default {
    state: {
        chatvisible: true,
        chat: undefined,
        chatsList:[],
        customerChat:{},
        chatKitDetails: undefined,
        price: {
            priceValue: "",
            currency: { name: "$" },
        },
        selectedType: { id: 0, name: "Message" },
        types: [
            { id: 0, name: "Message" },
            { id: 1, name: "Make an Offer" },
            { id: 2, name: "Attached file" },
        ],
        messages: [],
        months: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
        ],
        days: [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
            "Sunday",
        ],
    },
    getters: {
        chatsList: (state)=>{
            return state.chatsList;
        },
        customerChat: (state)=>{
            return state.customerChat
        },
        chat: (state) => {
            return state.chat;
        },
        chatKitDetails: (state) => {
            return state.chatKitDetails;
        },
        days: (state) => {
            return state.days;
        },
        months: (state) => {
            return state.months;
        },
        selectedType: (state) => {
            return state.selectedType;
        },
        types: (state) => {
            return state.types;
        },
        showChatDialog: (state) => {
            return state.chatvisible;
        },
        messages: (state) => {
            return state.messages;
        },
        price: (state) => {
            return state.price;
        },
    },
    mutations: {
        chatKitDetails(state, kit) {
            state.chatKitDetails = kit;
        },
        selectedType(state, type) {
            state.selectedType = type;
        },
        [SWITCH_CHAT_DIALOG](state) {
            state.chatvisible = !state.chatvisible;
        },
        [GET_MESSAGES]: (state, data) => {
            state.messages = data.messages;
            state.chat = data.chat;
            if (state.chat.chatId == undefined) state.chat.chatId = state.chat.id;
            if (state.chat.kitId == undefined) state.chat.kitId = state.chat.kit_id;
            if (state.chat.customerId == undefined)
                state.chat.customerId = state.chat.customer_id;
        },
        price(state, price, currency) {
            state.price.priceValue = price;
            state.price.currency = currency;
        },
        [ADD_MESSAGE]: (state, data) => {
            state.messages.push(data);
        },
        [UPDATE_MESSAGE]: (state, data) => {
            state.messages.forEach(function(key, item) {
                if (item.id == data.id) state.messages[key] = data;
            });
        },
        [CREATE_NEGOTIATION]: (state, data) => {},
    },
    actions: {
        [GET_CUSTOMER_CHATS]: async(context) => {
            var customerService = new CustomerService();
            var results = await customerService.getCustomerChats(
                context.getters.customer.id
            );
            context.state.chatsList = results.data.data
            if(!results.data.data) return [];
            return results.data.data;
        },

        [GET_CUSTOMER_CHAT]: async(context, id) => {
            var customerService = new ChatService();
            var results = await customerService.getChatById(id);
            context.state.customerChat = results.data.data
            if(!results.data.data) return [];
            return results.data.data;
        },

        [GET_MESSAGES]: async(context, kitId) => {
            var chatService = new ChatService();
            var results = await chatService.getSpecific(
                context.getters.customer.id,
                kitId
            );
            var data = {
                messages: results.data.data.content.messages,
                chat: results.data.data.content.chat,
            };
            context.commit(GET_MESSAGES, data);
            context.commit("chatKitDetails", results.data.data.kit);
            return results;
        },

        [GET_CHAT_MESSAGES]: async(context, chatId) => {
            var chatService = new ChatService();
            var results = await chatService.getChatMessages(chatId);
            var data = {
                messages: results.data.data.content.messages,
                chat: results.data.data.content.chat,
            };
            context.commit(GET_MESSAGES, data);
            context.commit("chatKitDetails", results.data.data.kit);
            let currencies = context.getters.currencies
            let kitCurrencyId = results.data.data.kit.currency_id
            
            let kitCurrency;
            currencies.forEach(function(currency)
            {
                if(currency.id==kitCurrencyId)
                {
                    kitCurrency = currency
                }
            })

            localStorage.setItem('kitCurrency', JSON.stringify(kitCurrency));
            context.commit(KIT_CURRENCY,kitCurrency)
        },

        [CREATE_MESSAGE]: async(context, data) => {
            var messageService = new MessageService();
            data.chat_id =
                data.chat_id == undefined ? context.getters.chat.id : data.chat_id;
            var results = await messageService.create(data);
            context.commit(ADD_MESSAGE, results.data);
            return results;
        },
        [UPDATE_MESSAGE]: async(context, data) => {
            var messageService = new MessageService();
            var result = await messageService.edit(data);
            return result;
        },
        [CREATE_NEGOTIATION]: async(context, data) => {
            let currentCurrency = context.getters.negotiationCurrency
            let kitCurrency = JSON.parse(localStorage.getItem('kitCurrency'));
            
            // data.amount = data.amount/currentCurrency.rate*kitCurrency.rate
            // data.currency = kitCurrency.id

            data.currency = currentCurrency.id

            var negotiationService = new NegotiationService();
            var result = await negotiationService.create(data);
            context.commit(CREATE_NEGOTIATION, data);
            return result;
        },
        [UPDATE_NEGOTIATION]: async(context, data) => {
            if(data.amount)
            {
                let currentCurrency = context.getters.negotiationCurrency
                let kitCurrency = JSON.parse(localStorage.getItem('kitCurrency'));
                data.amount = data.amount/currentCurrency.rate*kitCurrency.rate
                data.currency = kitCurrency.id
            }  
           
            var negotiationService = new NegotiationDetailService();
            var result = negotiationService.edit(data);
            return result;
        },
    },
};